import MuiCircularProgress, {
  CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material/CircularProgress';
import { CircularProgressProps } from './interface';
import React from 'react';

export const CircularProgress = (props: CircularProgressProps) => {
  return <MuiCircularProgress {...(props as MuiCircularProgressProps)} />;
};
